<span *ngIf="!isLink && displayText" [class.cropped]="cropped">
  {{ text }}
</span>
<a
  *ngIf="isLink"
  [attr.data-profile-overview-link-type]="linkType"
  [attr.data-profile-overview-link-text]="text"
  href="#"
  class="profile-link"
  [class.cropped]="cropped"
  data-automation-e2e-selector="accountLinkText"
>
  {{ displayText ? text : '' }}
  <ng-content></ng-content>
</a>
